export default "__VITE_ASSET__Gf7oQntm__"